import React from "react";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Group } from "@domain/group/group";
import { useModalTools } from "@ui/modals/modalContext";
import { KebabMenu } from "@ui/components/menus/kebabMenu";
import { SimpleMenuContent } from "@ui/components/menus/simpleMenuContent";
import { EditReferencePostModal } from "@ui/components/post/reference/editReferencePostModal";

interface DiscussionThumbnailMenuProps extends React.HTMLAttributes<HTMLDivElement> {
	discussion: Group;
}

export const DiscussionThumbnailMenu: React.FC<DiscussionThumbnailMenuProps> = ({ discussion, ...htmlProps }) => {
	const { createModal } = useModalTools();
	const currentProfile = useCurrentProfile();
	const isAuthor = discussion.owner.id === currentProfile?.id;
	return (
		<KebabMenu {...htmlProps}>
			<SimpleMenuContent
				onShare={() =>
					createModal((close) => (
						<EditReferencePostModal close={close} shared={{ type: "SHARE_GROUP", reference: discussion }} />
					))
				}
				reportInfos={
					isAuthor
						? undefined
						: {
								contentId: discussion.id,
								contentType: "GROUP",
							}
				}
			/>
		</KebabMenu>
	);
};
